import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';

import Tabs from '../../../../common/Tabs';
import SimpleHeader from '../../../headers/simpleHeader';
import { servicesProviderV2 } from '../../../services/hoc/servicesProvider';
import withCanCustomerCancel from './hoc/withCanCustomerCancel';
import withModel from './hoc/withModel';
import withOnSubmit from './hoc/withOnSubmit';
import withTabs, { tabsPropsTypes } from './hoc/withTabs';
import withReduxForm from './hoc/withReduxForm';
import withControls from './hoc/withControls';
import withHeading from './hoc/withHeading';
import withCommonData from './hoc/withCommonData';
import withFormState from './hoc/withFormState';
import LocationSelector from '../../formBarbers/barberForm/components/LocationSelector';
import { LOCATIONS_ALL_ID } from './constants';
import DynamicFormSection from './containers/DynamicNameFormSection';
import withBarberShops from './hoc/withBarberShops';
import withFetchedBarber from './hoc/withFetchedBarber';
import withOnTabClick from './hoc/withOnTabClick';
import BatchUpdateStatusModal from './components/BatchUpdateStatusModal';

const BrandBarber = ({ Controls, heading, tabs, ...props }) => (
  <React.Fragment>
    <SimpleHeader heading={heading} />
    <div className="c-wrapper">
      <div
        className="u-margin-auto u-max-width-710"
        display-if={props.errors}
      >
        <div className="c-login-error-message u-mb u-mt">
          {props.errors}
        </div>
      </div>
      <form onSubmit={props.handleSubmit}>
        <fieldset disabled={props.submitting}>
          <div
            className="u-margin-auto u-color-white u-max-width-1000"
            key={`${props.selectedLocation}-${props.activeTab}`}
          >
            <Tabs active={props.activeTab}>
              {tabs.map(({
                title,
                Component,
                showLocationSelector,
                useFormSection = true,
                getComponentProps = () => ({}),
              }, index) => (
                <Tabs.Tab
                  title={title}
                  key={title}
                  onTabClick={props.onTabClick}
                  disabled={props.isTabDisabled(index)}
                >
                  <div className="u-min-height-576 u-position-relative">
                    {useFormSection
                      ? (
                        <DynamicFormSection name={props.selectedLocation}>
                          <Component {...props} {...getComponentProps(props)} />
                        </DynamicFormSection>
                      )
                      : (
                        <Component {...props} {...getComponentProps(props)} />
                      )}
                    <div
                      className="u-position-absolute u-top-0 u-right-0 u-max-width-300 u-mr"
                      display-if={showLocationSelector}
                    >
                      <LocationSelector {...props} />
                    </div>
                  </div>
                </Tabs.Tab>
              ))}
            </Tabs>
            <Controls {...props} />
          </div>
        </fieldset>
      </form>
    </div>
    <BatchUpdateStatusModal {...props} />
  </React.Fragment>
);

BrandBarber.propTypes = {
  onTabClick: PropTypes.func,
  errors: PropTypes.node,
  handleSubmit: PropTypes.func.isRequired,
  selectedLocation: PropTypes.string,
  heading: PropTypes.node,
  ...tabsPropsTypes,
};

BrandBarber.defaultProps = {
  onTabClick: undefined,
  errors: null,
  selectedLocation: LOCATIONS_ALL_ID,
  activeTab: 0,
  heading: null,
};

export default compose(
  withCommonData,
  servicesProviderV2,
  withFetchedBarber,
  withBarberShops,
  withFormState,
  withHeading,
  withTabs,
  withControls,
  withModel,
  withOnSubmit,
  withOnTabClick,
  withReduxForm,
  withCanCustomerCancel,
)(BrandBarber);
